import { SVGProps } from 'react';

export const RangeOperatorNotBetween = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="7"
    viewBox="0 0 21 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="12"
      y="2.48438"
      width="8.26085"
      height="1.65213"
      fill="currentColor"
      fillOpacity="0.5"
    />
    <rect
      y="2.48438"
      width="8.26085"
      height="1.65213"
      fill="currentColor"
      fillOpacity="0.5"
    />
    <ellipse
      cx="5.35122"
      cy="3.30426"
      rx="3.30434"
      ry="3.30426"
      fill="currentColor"
    />
    <ellipse
      cx="14.7418"
      cy="3.30426"
      rx="3.30434"
      ry="3.30426"
      fill="currentColor"
    />
  </svg>
);
